import { AuthenticatedService } from "../../../../base/infrastructure";
import { IQuestionnaireVariableRepository, QuestionnaireVariableFhirPathItem } from "../../../domain/questionnaire";

export class QuestionnaireVariableRepository extends AuthenticatedService implements IQuestionnaireVariableRepository {
  constructor(getToken: () => string) {
    super(getToken);
  }

  async getFhirPath(): Promise<QuestionnaireVariableFhirPathItem[]> {
    return (await this.get("api/questionnaire/variable/fhir-path/get")).data;
  }

  async saveFhirPath(items: QuestionnaireVariableFhirPathItem[]): Promise<void> {
    await this.post("api/questionnaire/variable/fhir-path/save", items);
  }
}
